import { Action, createReducer, on } from '@ngrx/store'

import { initialMenu } from './inital-menu'
import { menuActions } from './menu.actions'
import { MenuState } from './menu.state'

export const initialState: MenuState = {
  menuItems: initialMenu,
  isLoading: false,
  ticketingControl: false
}

const reducer = createReducer(
  initialState,
  on(menuActions.setMenu, (state, { menuItems }) => ({
    ...state,
    menuItems,
    isLoading: false,
    ticketingControl: false
  })),
  on(menuActions.setTicketingControl, (state, { event }) => ({
    ...state,
    isLoading: false,
    ticketingControl: event
  }))
)

export function menuReducer(
  state: MenuState | undefined,
  action: Action
): MenuState {
  return reducer(state, action)
}
